import { render, staticRenderFns } from "./ProjectViewNotification.vue?vue&type=template&id=3edd0f11&"
import script from "./ProjectViewNotification.vue?vue&type=script&lang=js&"
export * from "./ProjectViewNotification.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edd0f11')) {
      api.createRecord('3edd0f11', component.options)
    } else {
      api.reload('3edd0f11', component.options)
    }
    module.hot.accept("./ProjectViewNotification.vue?vue&type=template&id=3edd0f11&", function () {
      api.rerender('3edd0f11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectViewNotification.vue"
export default component.exports